import { createContext } from 'react';
import { settings } from 'config';

const AppContext = createContext(settings);
export const AuthWizardContext = createContext({ user: {} });
export const SigningWizardContext = createContext({ signing: {} });
export default AppContext;
